export enum PopoverMenuItemType {
    SEPARATOR       = 'separator',
    HEADER          = 'header',
    // need Section name //
    SETTING         = 'setting',        // like toggle in view settings
    ITEM            = 'item',           // regular item
    MODAL           = 'modal',          // has on click but has arrow indicating that there will be modal....

    SUBMENU         = 'submenu',        // standard menu option with custom popover
    CUSTOM_POPOVER  = 'custom-popover', // standard menu option with popover with same menu options
    COMPONENT       = 'component',      // custom menu option component - DEPRECATED ... use custom Popover I think...
}


export type MenuOption             = Option & {

    isPro?                              : boolean // deprecated ... use Feature to check

    onClickUpgrade?                     : callback // used in popoverMenuOption

    // value?                          : any
    // label?                          : string
    // description?                    : string // is used at least in FieldDropdown
    // color?                          : number
    // icon?                           : string
    // iconComponent?                  : any
    // disabled?                       : boolean
    // isSelected?                     : boolean
    // counter?                        : number        // use to set counter for option
    // hint?                           : string    // need help here :)
    //
    // type?                           : PopoverMenuItemType
    // options?                        : Option[]
    //
    // title?                          : string // used for headers
    //
    // excludeFromSelectable?          : boolean // is option excluded from visible in popover
    // isAllValuesOption?              : boolean
    // showLabelFromSelectedOption?    : boolean // is used for PopoverMenuItemType.POPOVER to show label from selected subOption
    //
    // onClick?                        : callback // used in popoverMenuOption
    //
    // helpMessage?                    : string,       // ???
    //
    // component?                      : any // custom tsx component - used when option is very custom
    // menuComponent?                  : any // used to build popover sub menus
    // menuParams?                     : any // used to build popover sub menus
    //
    // //for PopoverMenuItemType.CUSTOM_POPOVER
    // popoverClass?                   : string
    // popoverContentClass?            : string
    // popoverStyles?                  : any
    // popoverContentStyles?           : any
    // outsideClickIgnoreClasses?      : string[] | string
    // popoverOffset?                  : string
    // onTogglePopover?                : {(showPopover: boolean, component: any): void}
}

export function OptionHeader(title:string):Option {
    return {
        type    : PopoverMenuItemType.HEADER,
        title   : title
    }

}

export function OptionSeparator():Option {
    return {
        type    : PopoverMenuItemType.SEPARATOR
    }
}

export type PopoverMenuProps = {
    hidePopover                 : callback,
    menuParams                  : any,
    onPopoverKeyDownListener    : callback

}
